import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import { useAuthStore } from './stores/auth'
import './styles/global.css'
import App from './app/App.vue'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Восстанавливаем сессию пользователя при загрузке приложения
const authStore = useAuthStore()
authStore.restoreSession().catch((error) => {
  console.error('Failed to restore session:', error)
})

app.mount('#app')
